import { Component, OnDestroy, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { CookieService } from "ngx-cookie-service";
import { Subscription } from "rxjs";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { DeviceService } from "src/app/core/services/device.service";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
import { locationBroadcastService } from "src/app/core/services/loaction-broadcast.service";
import { OsAppService } from "src/app/core/services/master/os-app.service";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { ApiService } from "src/app/services/api";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';

@Component({
  selector: 'app-quick-actions',
  templateUrl: './quick-actions.component.html',
  styleUrls: ['./quick-actions.component.scss']
})
export class QuickActionsComponent implements OnInit, OnDestroy {
  breadcrumbItems: breadcrumbItem[] = [
    {
      label:'Home',
      active:false,
      url:'/home'
    },
    {
      label: 'Merchants',
      active: true,
      url: "",
    },
  ];

  active = 5;
  isLoadingChangeSub: Subscription;
  isLoading = false;
  userData = null;
  GLOBALURL: string;
  f = true; // Flag to show/hide form
  businessForm: FormGroup;
  showErrorBanner = false;
  isSubmitted = false;

  headerToken = {
    Authorization: this.cookieService.get('Authorization'),
  };

  httpOptions = {
    headers: new HttpHeaders(this.headerToken)
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private deviceService: DeviceService,
    private osAppService: OsAppService,
    private cookieService: CookieService,
    private store: Store<AppState>,
    private toastr: AlertService,
    private locService: locationBroadcastService,
    private authService: AuthenticationService,
    private ApiService: ApiService,
    private BreadcrumbService: BreadcrumbService,
    private http: HttpClient,
    private fb: FormBuilder
  ) {
    this.osAppService.GLOBALURL = this.ApiService.getBaseURL();
    this.initializeForm();
  }

  ngOnInit(): void {
    this.BreadcrumbService.setValue(this.breadcrumbItems);
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.GLOBALURL = this.ApiService.getBaseURL();

    this.userData = this.authService.getUserFromLocalStorage();
    this.isLoadingChangeSub = this.osAppService.isLoadingChangeSub.subscribe(
      (isLoading) => (this.isLoading = isLoading)
    );

    this.store.dispatch(setLoadingSpinner({ status: false }));
  }

  initializeForm() {
    this.businessForm = this.fb.group({
      businessFormInfoData: this.fb.group({
        accountHolderIds: this.fb.array([this.fb.control('', Validators.required)])
      })
    });
  }

  get accountHolderControls() {
    return (this.businessForm.get('businessFormInfoData.accountHolderIds') as FormArray).controls;
  }

  addAccountHolder() {
    const accountHolderArray = this.businessForm.get('businessFormInfoData.accountHolderIds') as FormArray;
    accountHolderArray.push(this.fb.control('', Validators.required));
    this.isSubmitted = false;
  }

  removeAccountHolder(index: number) {
    const accountHolderArray = this.businessForm.get('businessFormInfoData.accountHolderIds') as FormArray;
    accountHolderArray.removeAt(index);
  }

  onSubmit() {
    this.isSubmitted = true;
    
    if (this.businessForm.valid) {
      this.store.dispatch(setLoadingSpinner({ status: true }));
      const accountHolderIds = (this.businessForm.get('businessFormInfoData.accountHolderIds') as FormArray).value;
      
      this.http
        .post(`${this.GLOBALURL}/adyen/close/accountHolder`, { accountHolderIds }, this.httpOptions)
        .subscribe(
          (response: any) => {
            if (response.success === 0) {
              this.toastr.error(response.message);
            } else {
              // Reset form and submission state
              this.businessForm.reset();
              this.isSubmitted = false;
              const accountHolderArray = this.businessForm.get('businessFormInfoData.accountHolderIds') as FormArray;
              while (accountHolderArray.length > 1) {
                accountHolderArray.removeAt(1);
              }
              
              this.toastr.success(response.message || 'Account holders closed successfully');
              
              // Redirect back to quick actions
              this.router.navigate(['/merchants/quick-actions']);
            }
            this.store.dispatch(setLoadingSpinner({ status: false }));
          },
          (error) => {
            this.toastr.error(error?.error?.message || error?.message || 'An error occurred');
            this.store.dispatch(setLoadingSpinner({ status: false }));
          }
        );
    }
  }

  ngOnDestroy(): void {
    if (this.isLoadingChangeSub) {
      this.isLoadingChangeSub.unsubscribe();
    }
  }

  goBack() {
    this.router.navigate(["../"], { relativeTo: this.route });
  }
}
